<div class="school-dashboard-page">

  <!-- Header bar -->
  <div class="school-dashboard-header">
    <span>School Dashboard</span>
    <button class="btn print-summary-button" (click)="printPage()">
      <fa-icon [icon]="printIcon"></fa-icon> Print
    </button>
  </div>

  <div *ngIf="loadError" class="alert alert-danger school-dashboard-error">{{ loadError }}</div>

  <!-- Login date range -->
  <div class="date-range-row">
    <label class="date-range-label" for="schoolDashboardDateRange">Login date range</label>
    <select id="schoolDashboardDateRange" [(ngModel)]="dateRange" (change)="loadRangeData()">
      <option *ngFor="let range of dateRanges" [ngValue]="range">{{ range.rangeDisplay }}</option>
    </select>
  </div>

  <!-- Top summary cards -->
  <div class="summary-cards-row">
    <div class="summary-card">
      <fa-icon [icon]="teacherIcon" class="summary-card-icon teacher-icon"></fa-icon>
      <div class="summary-card-body">
        <div class="summary-card-count">{{ teacherCount }}</div>
        <div class="summary-card-label">Teachers</div>
      </div>
    </div>
    <div class="summary-card">
      <fa-icon [icon]="studentsIcon" class="summary-card-icon students-icon"></fa-icon>
      <div class="summary-card-body">
        <div class="summary-card-count">{{ enrolledCount }}</div>
        <div class="summary-card-label">Students Enrolled</div>
      </div>
    </div>
  </div>

  <!-- Main content section -->
  <div class="dashboard-content-section">

    <!-- Engagement row -->
    <div class="engagement-row">

      <!-- Classroom Engagement -->
      <div class="engagement-card">
        <div class="engagement-card-title">Classroom Engagement</div>
        <div class="engagement-layout">
          <div class="gauge-area">
            <wf-report-gauge
              #classroomGauge
              [percent]="classroomEngagementPercent"
              [color]="'#0054A6'"
              [backgroundColor]="'#DFDFDF'">
            </wf-report-gauge>
            <div class="gauge-overlay">
              <div class="gauge-main-value">{{ classroomsAbove60 }} of {{ totalClassrooms }}</div>
              <div class="gauge-sub-label">Classrooms with at least<br>60 minutes usage per week</div>
            </div>
          </div>
          <div class="top-list-area">
            <div class="top-list-header classroom-header">Top Classroom Engagement</div>
            <div *ngFor="let item of topClassroomEngagement" class="top-list-item">
              <span class="top-list-value">{{ item.displayValue }}</span>
              <span class="top-list-sep"> - </span>
              <span class="top-list-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Teacher Usage -->
      <div class="engagement-card">
        <div class="engagement-card-title">Teacher Usage</div>
        <div class="engagement-layout">
          <div class="gauge-area">
            <wf-report-gauge
              #teacherGauge
              [percent]="teacherLoginPercent"
              [color]="'#80C342'"
              [backgroundColor]="'#DFDFDF'">
            </wf-report-gauge>
            <div class="gauge-overlay">
              <div class="gauge-main-value">{{ teacherLoginPercent }}%</div>
              <div class="gauge-sub-label">Teachers with at least<br>one login per week</div>
            </div>
          </div>
          <div class="top-list-area">
            <div class="top-list-header teacher-header">Top Teacher Logins</div>
            <div *ngFor="let item of topTeacherLogins" class="top-list-item">
              <span class="top-list-value">{{ item.displayValue }}</span>
              <span class="top-list-sep"> - </span>
              <span class="top-list-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Student Engagement -->
    <div class="student-engagement-section">
      <div class="student-engagement-title">Student Engagement</div>

      <div class="student-engagement-body">

        <!-- Donut chart -->
        <div class="donut-wrapper">
          <div class="donut-chart-container">
            <canvas baseChart
              [data]="donutData"
              [type]="donutType"
              [options]="donutOptions"
              [plugins]="donutPlugins">
            </canvas>
          </div>
          <div class="donut-center-label">Average Minutes / Week</div>
        </div>

        <!-- Breakdown key -->
        <div class="breakdown-key">
          <div class="breakdown-key-header">Student Minutes per week</div>

          <div class="breakdown-key-highlight">
            <div class="breakdown-row">
              <span class="breakdown-pct highlight-pct">{{ breakdownPercents[4] }}</span>
              <span class="breakdown-swatch" style="background:#B2D235;"></span>
              <span class="breakdown-label">80+ minutes</span>
            </div>
            <div class="breakdown-row">
              <span class="breakdown-pct highlight-pct">{{ breakdownPercents[3] }}</span>
              <span class="breakdown-swatch" style="background:#0095DA;"></span>
              <span class="breakdown-label">60-79 minutes</span>
            </div>
          </div>

          <div class="breakdown-row breakdown-divider">
            <span class="breakdown-pct">{{ breakdownPercents[2] }}</span>
            <span class="breakdown-swatch" style="background:#007236;"></span>
            <span class="breakdown-label">40 - 59 minutes</span>
          </div>
          <div class="breakdown-row breakdown-divider">
            <span class="breakdown-pct">{{ breakdownPercents[1] }}</span>
            <span class="breakdown-swatch" style="background:#8CCEEE;"></span>
            <span class="breakdown-label">20 - 39 minutes</span>
          </div>
          <div class="breakdown-row">
            <span class="breakdown-pct">{{ breakdownPercents[0] }}</span>
            <span class="breakdown-swatch" style="background:#555555;"></span>
            <span class="breakdown-label">0 - 19 minutes</span>
          </div>
        </div>

        <!-- 60+ box and top by teacher -->
        <div class="right-panel">
          <div class="sixty-plus-box">
            <div class="sixty-plus-pct">{{ total60PlusPercent }}%</div>
            <div class="sixty-plus-label">Students getting<br>60 min or more</div>
          </div>
          <div class="top-usage-section">
            <div class="top-usage-header">Top Student Usage by Teacher</div>
            <div *ngFor="let item of topStudentUsageByTeacher" class="top-list-item">
              <span class="top-list-value-blue">{{ item.displayValue }}</span>
              <span class="top-list-sep"> - </span>
              <span class="top-list-name">{{ item.name }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Student Units -->
    <div class="student-units-section">
      <div class="student-units-row">
        <div class="student-units-header-box">Student Units</div>
        <div class="student-units-stat">
          <span class="student-units-count">{{ studentsWithUnit }}</span>
          <span class="student-units-label">Students</span>
        </div>
        <div class="student-units-bar-wrapper">
          <div class="student-units-bar-track">
            <div class="student-units-bar-fill" [style.width.%]="unitBarPercent"></div>
          </div>
          <div class="student-units-bar-caption">Students getting at least one unit per week &mdash; current academic year</div>
        </div>
      </div>
    </div>

  </div>
</div>
